import styled from 'styled-components';

export const StyledSpinner = styled.div`
  background-color: #d1d1d1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
